<template>
    <div class="center" id="parentCanvas">
      <div id="loading"></div>
      <div class="card-content is-flex is-horizontal-center">
        <div id="previewcanvas"></div>
      </div>
      <div id="userWaitAMinuteNotification"></div>
      <img id="capturedPhoto"/>
</div>
</template>

<script>
  import CryptoJS from 'crypto-js'

  /* Package for using camera */
  import getUserMedia from 'getusermedia'

  /* Modal to use camera */
  import createNewAvatarModal from './createNewAvatarModal.vue'
  import cameraModal from './cameraModal.vue'

  export default {
    name: 'didimoModal',
    data: function() {
      return {
        avatar: '',

        /* Data needed to Authorization string */
        secret_key: 'test_secret_key_eval253498',
        realm: 'Avatar',
        auth_method: "sha256",
        auth_key: "test_api_key_eval253498",
        auth_nonce: '',
        auth_digest: '',

        /* auth_uri must be exactly same as request for algorithm to work */
        auth_uri: '/api/latest/didimo/"' + this.$store.getters.avatar.didimoKey + '"/download/fbx"',

      }
    },
    mounted() {
        if((this.$store.getters.avatar.hasAvatar)){
          this.getDidimoFBX('https://mydidimo.com/api/latest/didimo/' + this.$store.getters.avatar.didimoKey + '/download/fbx')
        }
    },
    methods: {
      changeHasAvatarBoolean(boolean) {
        this.$store.dispatch('changeHasAvatar', boolean)
      },
      changeDidimoKey(key) {
        this.$store.dispatch('changeDidimoKey', key)
      },


      /* Need this function for the getDidimoImage function to use out of range characters for encoding/decoding */
      Uint8ToString(u8a) {
        var CHUNK_SZ = 0x8000
        var c = []
        for (var i=0; i < u8a.length; i+=CHUNK_SZ) {
          c.push(String.fromCharCode.apply(null, u8a.subarray(i, i+CHUNK_SZ)))
        }
        return c.join("")
      },


      /* Method that gets the FBX file from server and then renders the avatar.
         Using nearly same exact code as on the eval.mydidimo.com page
      */
      getDidimoFBX(newsrc) {
        var self = this

        /* Authorization string must take a new Nonce and digest every call */
        var AuthString = 'DidimoDigest '.concat('realm="Avatar",').concat(" ").concat('auth_method="sha256",').concat(" ").concat('auth_key="test_api_key_eval253498",').concat(" ").concat('auth_nonce="'+self.randomNonce+'",').concat(" ")
        .concat('auth_digest="'+self.randomDigest+'"')

        var xhr = new XMLHttpRequest()
        xhr.open('GET', newsrc, true)
        xhr.setRequestHeader('Authorization', AuthString)
        xhr.setRequestHeader('Accept', '*/*')
        xhr.responseType = 'arraybuffer'
        xhr.onload=function() {
          /* Packages needed to render avatar on WebGLRenderer */
          var THREE = require('three')

            var fbxFile ='data:'+xhr.getResponseHeader('content-type')+';base64,'+btoa(self.Uint8ToString(new Uint8Array(xhr.response)))
            var innerSelf = this

            /* PerspectiveCamera sets the initial render position of the avatar when page loads */
            var camera = new THREE.PerspectiveCamera( 35, 1, 1, 2000 )

            var scene = new THREE.Scene()
            // scene.background = new THREE.Color( 0x000000 );

            var mixers = []
            var renderer

            //defalt options, settable by url
            var options = {
              audiourl:'audio.pcm',
              visemesurl:'visemes.txt',
              controls3d:true,
              controlsAudio:true,
              initialDistance:60,
              autoplay:false,
              camTarget:"head",
              camAdjust:"0,0,0",
              fbxfile:'avatar_model.fbx',
              posesfile:null,//"poses_diff_auto.json",
              clearColor:0x222222,
              animSyncMillis: -100,
              maxBlendMillis: 150,
              // didimo:null,
              sceneInfoFile:null
            }

            if ( ! Detector.webgl ) Detector.addGetWebGLMessage()

            window._getvar = window._getvar || function(n) {var r; if(r=(new RegExp("[?&]" + String(n).replace(/[\[\]]/g, "\\$&")  + "(=([^&#]*)|&|#|$)")).exec(window.location.href)) r=r[2]&&decodeURIComponent(r[2].replace(/\+/g, " "))||''; return r;}

            function parseUrl(query){
              var urlParams
              var match,
                      pl     = /\+/g,  // Regex for replacing addition symbol with a space
                      search = /([^&=]+)=?([^&]*)/g,
                      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); }
              urlParams = {}
              while (match = search.exec(query)) {
                  var decoded = decode(match[2])
                  try{
                    decoded = JSON.parse(decoded)
                  }catch(e){}
                  urlParams[decode(match[1])] = decoded
              }
              return  urlParams
            }
            var urlParams = parseUrl( window.location.search.substring(1) )

            for(var i in urlParams){
              options[i] = urlParams[i]
            }

            if(options.didimo !== null){
                var didimodir = 'https://' + 'mydidimo.com/api/latest/didimo/' + self.$store.getters.avatar.didimoKey + '/preview';
                options.fbxfile = didimodir + '/avatar_model.fbx';
                options.sceneInfoFile = didimodir + "/scene_info.json";
            }

            var previewcanvas = document.getElementById("previewcanvas") || document.body


            function getRenderHeight(){
                // return previewcanvas.clientHeight;
                return window.innerHeight * 0.7
            }
            function getRenderWidth(){
                // return previewcanvas.clientWidth;
                return window.innerWidth * 0.7
            }
            function halfway(a,b){
              return a+(b-a)/2;
            }

            var helpers = []
            function addHelper(helper){
              helpers.push(helper)
              scene.add(helper)
            }
            function updateHelpers(){
              for(var i=0; i<helpers.length; i++){
                helpers[i].update()
              }
            }


            var mesh
            var controls

            var poses = {}
            var visemeList = []

            var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1
            var antialias = (pixelRatio == 1)

            // model
            var manager = new THREE.LoadingManager()
            manager.onStart = function(url, itemsLoaded, itemsTotal) {
              console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' )
            };
            manager.onProgress = function(item, loaded, total) {
              console.log(item, loaded, total)
            };
            manager.onLoad = function() {
              console.log('Loading Complete!')
              // onWindowResize();

              head.add(mesh)
              head.visible=true

              // if(visemeList && visemeList.length > 0 && audio && audio.src)
              //   setTimeout(function(){ audio.play() },0);
            }
            manager.onError = function(url) {
              console.log('There was an error loading: ' + url)
            }

            var onProgress = function(xhr) {
              if (xhr.lengthComputable) {
                var percentComplete = xhr.loaded / xhr.total * 100
                console.log(Math.round(percentComplete, 2) + '% downloaded')
              }
            }
            function onError( error ) {
              console.error(error)
            }

            function globalLoadProgressManager(xhr){
                var xhrp = 0

                if(xhr.lengthComputable){
                  xhrp = xhr.loaded / xhr.total
                }else{
                  xhrp = 0
                }

                var percentComplete = (xhrp + manager.loaded)/manager.total * 100
                var _s = document.getElementById("loading").style
            		_s.transition = "all 100ms"
            		_s.width = (~~percentComplete)+"%"
            }

            var fbxLoader = new THREE.FBXLoader(manager)
            var imageLoader = new THREE.ImageLoader(manager)
            var fileLoader = new THREE.FileLoader(manager)
            var jsonLoader = new THREE.JSONLoader(manager)
            var objectLoader = new THREE.ObjectLoader(manager)

            /* Need to force local paths for .jpg assets to load correctly */
            THREE.FBXLoader.forceLocalPaths = true

            var clock = new THREE.Clock()
            clock.start()

            renderer = new THREE.WebGLRenderer({antialias: antialias, logarithmicDepthBuffer: true, alpha: true})
            renderer.setPixelRatio( window.devicePixelRatio )
            renderer.setSize( 350 , 400)
            renderer.setClearColor( 0xffffff, 0 )
            previewcanvas.appendChild( renderer.domElement )

            var head = new THREE.Group()
            scene.add(head)


            /* TRACKBALL CONTROLS */
            var controls = new THREE.TrackballControls(camera,renderer.domElement)
            controls.rotateSpeed = 1.0
            controls.zoomSpeed = 0.2
            controls.panSpeed = 0.8
            controls.noRotate = false
            controls.noZoom = false
            controls.noPan = true
            controls.dynamicDampingFactor = .4
            controls.keys = [ 65, 83, 68 ]
            controls.target.set( 0, 0, 0 )
            controls.minDistance = 20
            controls.maxDistance = 80
            controls.enabled = options.controls3d

            var light_ambient = new THREE.AmbientLight(0x606060)
            scene.add(light_ambient)

            var light_camera = new THREE.DirectionalLight(0xFFEFE1,0.80)
            controls.addEventListener( 'change', light_update )
            function light_update()
            {
                light_camera.position.copy( camera.position )
                light_camera.position.y = 0
            }
            light_camera.position.copy( camera.position )
            scene.add(light_camera)

            if(options.posesfile)
            fileLoader.load(options.posesfile, function (js) {
                var ps =  JSON.parse(js)
                for(var n in ps)
                  if(n!="rest")
                    poses[n] = ps[n]
            },globalLoadProgressManager)

            function loadFBX(sceneInfo){
                  var bbcenter
                  var bbtarget

                  if(sceneInfo && sceneInfo.eyes_center && sceneInfo.head_center){
                      var eyes_center = new THREE.Vector3().fromArray(sceneInfo.eyes_center)
                      var head_center = new THREE.Vector3().fromArray(sceneInfo.head_center)
                      bbcenter = new THREE.Vector3().addScaledVector(eyes_center,.5).addScaledVector(head_center,.5)
                      bbcenter.z = head_center.z
                      console.log(sceneInfo)
                  }

                  fbxLoader.load(options.fbxfile, function( m ) {
                      mesh = m

                      if(!bbcenter){ //no scene file, autodetect
                          if(bbtarget = mesh.getObjectByName(options.camTarget)){
                            var bb = new THREE.Box3().setFromObject(bbtarget)
                            bbcenter = new THREE.Vector3(halfway(bb.min.x,bb.max.x),halfway(bb.min.y,bb.max.y),halfway(bb.min.z,bb.max.z))
                          }else{
                            console.error("camTarget", options.camTarget , "not found!")
                          }
                      }

                      var camAdjust = options.camAdjust && options.camAdjust.split(',')
                      if(typeof camAdjust === typeof []){
                          bbcenter.x += Number(camAdjust[0])
                          bbcenter.y += Number(camAdjust[1])
                          bbcenter.z += Number(camAdjust[2])
                      }
                      camera.lookAt(bbcenter)
                      camera.position.x = 0
                      camera.position.y = bbcenter.y
                      camera.position.z = options.initialDistance

                      if(controls)
                          controls.target = bbcenter

                      //generate rest pose
                      mesh.skeleton.bones.forEach(function(bone){
                        var name = bone.name
                        if(!poses.rest)poses.rest={}
                        if(!poses.rest[name])poses.rest[name] = {}
                        if(!poses.rest[name].translation)poses.rest[name].translation = [0,0,0]
                        if(!poses.rest[name].rotation)poses.rest[name].rotation = [0,0,0]
                        if(!poses.rest[name].scale)poses.rest[name].scale = [1,1,1]
                        poses.rest[name].translation = bone.position.toArray()
                        poses.rest[name].rotation = bone.rotation.toArray()
                        poses.rest[name].scale = bone.scale.toArray()
                      })

                      //regardless of choice of materials
                      //force skinning
                      mesh.traverse(function(m){
                          if(m.isSkinnedMesh && m.material && !m.material.skinning){
                            m.material.skinning = true
                          }
                      })

                      if (document.body.classList)
                        document.body.classList.add("hasVisual")
                      else
                        document.body.className += ' ' + "hasVisual"

                      // fix z-buffer problems with eyelashes
                      var lashesOrder = 10
                      mesh.traverse(function(child) {
                        if(child instanceof THREE.Mesh && String(child.name).match("lashes"))
                        {
                          child.renderOrder = lashesOrder
                          child.material.side = THREE.DoubleSide
                          child.material.depthWrite = false
                        }
                      })

                  }, onProgress, onError )

              }

              if(options.sceneInfoFile)
              fileLoader.load(options.sceneInfoFile,function(sceneInfo){
                  try{
                      sceneInfo = JSON.parse(sceneInfo)
                  }catch(e){
                      console.log("can't parse scene_info, continue with options/defaults")
                      sceneInfo = null
                  }
                  loadFBX(sceneInfo)
              },undefined,function(data){
                  console.log("no scene_info, continue with options/defaults")
                  loadFBX(null)
              })



              function animate(){
                  requestAnimationFrame(animate)
                  render()
              }
              animate()

              var maxFPS = 60
              var renderPtime = 0
              var oldposition = 0
              function render() {

                  var ctime = (new Date()).getTime()
                  if(!window.audio || window.audio.paused)
                      if((ctime-renderPtime) < 1000/maxFPS)
                          return

                  renderPtime = ctime

                  var delta = clock.getDelta()

                  window.stats&&stats.update()

                  window.animate_triggers&&animate_triggers()

                  window.updateHelpers&&updateHelpers()

                  var controlsAreQuiet = true

                  if(controls){
                      controls && controls.update()

                      //throttle
                      var co = controls.object
                      co.up.x+=(0-co.up.x)*(delta*8)
                      co.up.y+=(1-co.up.y)*(delta*8)
                      co.up.z+=(0-co.up.z)*(delta*8)
                      var p = Math.abs(co.position.x)+Math.abs(co.position.y)+Math.abs(co.position.z)
                      controlsAreQuiet = Math.abs(p-oldposition)<0.000001
                      oldposition = p
                  }

                  var slow = (window.audio && audio.paused) && controlsAreQuiet

                  maxFPS = slow ? 10 : 50

                  //should not be needed if we don't change cameras, but a bug on some chrome versions
                  //create dragging effect
                  //renderer.clear();
                  renderer.render( scene, camera )
              }

              function populate(){
                var objects = {unnamed:[]}
                mesh.traverse(function(o){

                  if(o.name){
                      if(window[o.name])
                        console.log("window."+o.name+" already exists")
                      else {
                        window[o.name] = o
                      }
                  }

                  if(o.name)
                    objects[o.name]=o
                  else
                    objects.unnamed.push(o)

                })
              }

              function setupDatGui () {
                var gui = new dat.GUI()
              	var folder = gui.addFolder( "BONES" )

              	var bones = mesh.skeleton.bones

                var BoneSelect = function(bone){
                  this.bone = bone
                  this.bonename = bone.name
                  this.selectbone = function(){
                      tcontrol.attach(this.bone)
                  }
                }

              	for ( var i = 0; i < bones.length; i ++ ) {
                  var boneSelect = new BoneSelect(bones[i])
                  folder.add(boneSelect,'selectbone').name(bones[i].name.replace('Template',''))
              	}

                folder.open()
                scene.add(skeletonHelper = new THREE.SkeletonHelper(scene))
              }

              function seeBones(){
                setTimeout(function(){
                    var scriptGui=document.createElement('script')
                    scriptGui.onload=setupDatGui
                    scriptGui.src='dat.gui.js'
                    document.head.appendChild(scriptGui)
                },100)
              }
          }
          xhr.send(null)
      },
        requestAnimationFrame() {
            return (
                window.requestAnimationFrame       ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame    ||
                window.oRequestAnimationFrame      ||
                window.msRequestAnimationFrame     ||
                function(/* function */ callback){
                    window.setTimeout(callback, 1000 / 60)
                }
            )
        },
    },
    computed: {
      /* Randomizes each Nonce for each call using Authorization header */
      randomNonce() {
        var text = "";
        var possible = "abcdefghijklmnopqrstuvwxyz0123456789"
        for (var i = 0; i < 11; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length))
        }
        return text
      },
      /* Randomizes each Digest for each call using Authorization header */
      randomDigest() {
        var digest = CryptoJS.HmacSHA256((CryptoJS.SHA256(this.auth_key + this.secret_key) + CryptoJS.SHA256(this.auth_key + this.randomNonce + this.auth_uri)), this.secret_key)
        return digest
      },
    },
    components: {
      createNewAvatarModal: createNewAvatarModal,
      cameraModal: cameraModal,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center {
  margin: auto;
  width: 90%;
  padding: 10px;
}
.is-horizontal-center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar/didimoModal.vue